import React, { memo } from 'react';
import { Autocomplete, Checkbox, Stack, TextField } from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import theme from 'styles/theme';
import FormControl from '@mui/material/FormControl';
import { TypeOption } from '../../pages/Admin/NewFileSetUpPage/hook';
export type OptionAutocomplete = {
  label: string;
  value: string;
};

type MultiSelectAutocompleteProps = {
  value?: TypeOption[];
  onChange: (event: React.SyntheticEvent, value: TypeOption[]) => void;
  options: TypeOption[];
  label?: string;
  title?: string;
};
const MultiSelectAutocomplete = ({
  value,
  onChange,
  options,
  label,
  title
}: MultiSelectAutocompleteProps) => {
  const isSelected = (option: TypeOption) =>
    value?.some((selectedOption) => selectedOption.value === option.value);
  return (
    <FormControl fullWidth>
      {title && (
        <FormLabel>
          <Typography fontSize={'13px'} fontWeight={500} mb={1} color={theme.colors.dark1}>
            {title}
          </Typography>
        </FormLabel>
      )}
      <Autocomplete
        multiple
        options={options}
        disableCloseOnSelect
        value={value || []}
        onChange={onChange}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderTags={() => null}
        renderOption={(props, option) => {
          const checked = isSelected(option);
          return (
            <li
              {...props}
              style={{
                backgroundColor: checked ? 'rgba(0, 123, 255, 0.1)' : 'inherit'
              }}>
              <Checkbox checked={checked} style={{ marginRight: 8 }} />
              <Typography
                fontSize="14px"
                fontWeight={600}
                sx={{ letterSpacing: '-0.2px', color: theme.colors.dark1 }}>
                {option.label.split(' (')[0]}{' '}
                <Typography
                  component="span"
                  fontWeight={400}
                  fontSize="14px"
                  color={theme.colors.dark1}>
                  {option.label.match(/\(([^)]+)\)/)?.[1] || ''}
                </Typography>
              </Typography>
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={label || 'Search/Add'} />
        )}
      />

      {value && value.length > 0 && (
        <Stack spacing={1.25} mt={1.25} gap={1.25} flexDirection={'row'} flexWrap={'wrap'}>
          {value.map((item) => (
            <Stack
              key={item.value}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: 'fit-content',
                background: '#A9BDBF',
                borderRadius: '24px',
                px: 2,
                py: 0.75,
                height: '36px',
                marginTop: '10px !important'
              }}>
              <Typography
                fontSize="14px"
                fontWeight={600}
                sx={{ letterSpacing: '-0.2px', color: theme.colors.dark1 }}>
                {item.label.split(' (')[0]}{' '}
                <Typography
                  component="span"
                  fontWeight={400}
                  fontSize="14px"
                  color={theme.colors.dark1}>
                  {item.label.match(/\(([^)]+)\)/)?.[1] || ''}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  ml: 2,
                  cursor: 'pointer',
                  fontWeight: 700,
                  color: '#2E3A3E'
                }}
                onClick={() =>
                  onChange(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    {} as any,
                    value.filter((v) => v.value !== item.value)
                  )
                }>
                ✕
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </FormControl>
  );
};

export default memo(MultiSelectAutocomplete);
